import type { RouteRecordRaw } from 'vue-router';
import { EMPLOYEE_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const employeeManagementRoutes: RouteRecordRaw = {
  path: '/employee-management',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      name: EMPLOYEE_ROUTE_NAME.LIST_EMPLOYEE,
      path: '',
      component: () => import('./EmployeeManagement.vue'),
    },
  ],
};
